module.exports = __webpack_public_path__ + "static/media/checkoutTransactions.dc1e3223.svg";